import type { ReactNode } from 'react';

import { CTA_BOTTOM_PAD } from './TabLayout';

/**
 * 탭바를 감춘 드릴다운 화면의 바닥 CTA(시안 `bottom cta`) — 페이지 배경색 띠 위에 54px
 * 검은 알약 하나. 언어 선택·프로필 수정이 쓴다.
 *
 * `sticky` 라 본문이 짧으면 흐름 끝에 서고, 길면 화면 바닥에 붙는다 — 쓰는 화면의 본문이
 * `flex-1` 로 남은 높이를 차지해야 짧은 화면에서도 바닥에 선다. 띠가 배경색을 칠하므로
 * 밑으로 지나가는 본문이 버튼 옆으로 비치지 않는다.
 *
 * 의견 남기기의 흰 둥근 바와는 다른 시안이다 — 합치지 않는다.
 */
export const BottomCta = ({
  onClick,
  disabled = false,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}) => (
  <div
    className="sticky bottom-0 z-10 bg-background px-4 pt-3"
    style={{ paddingBottom: CTA_BOTTOM_PAD }}
  >
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex h-[54px] w-full items-center justify-center rounded-full bg-black text-base font-bold tracking-[-0.08px] text-white disabled:bg-bk-300 disabled:text-bk-800"
    >
      {children}
    </button>
  </div>
);
